import Vue from "vue"
import {formatDictData} from "~/utils/index"

const state = Vue.observable({ 
  dictConfig: {},
  dictCodes: {},
  isGettingDictTypes: [], //正在请求字典类型数组 防止多个请求
  isGettingAllDictTypes: false, //正在请求所有字典数据
  unfindDictTypes: [] //防止重复请求没有的字典数据
})

const mutations = {
  //设置字典设置
  SET_DICT_SETTING(setting) {
    state.dictConfig = setting
  },
  //设置字典数据值
  SET_DICT_CODES(dictData) {
    state.dictCodes = dictData
  },
  //添加正在请求的字典类型字段
  ADD_IS_EGTTING_DICT_TYPES(typesStr) {
    const dictArr = typesStr.split(",")
    const isGettingArr = [...dictArr, ...state.isGettingDictTypes]
    const targetArr = new Set(isGettingArr)
    state.isGettingDictTypes = Array.from(targetArr)
  },
  //去除正在请求的字典类型字段
  REMOVE_IS_EGTTING_DICT_TYPES(typesStr) {
    const dictArr = typesStr.split(",")
    //arr1有 arr2没有的差集
    const targetArr = [...new Set(state.isGettingDictTypes)].filter(item => !new Set(dictArr).has(item))
    state.isGettingDictTypes = Array.from(targetArr)
  },
  //设置是否正在请求所有字典数据
  SETTING_ISGETTING_ALL_DICT_TYPES(status) {
    state.isGettingAllDictTypes = status
  },

  //添加找不到的字典类型字段
  ADD_UNFIND_DICT_TYPES(typesStr) {
    const dictArr = typesStr.split(",")
    const isGettingArr = [...dictArr, ...state.unfindDictTypes]
    const targetArr = new Set(isGettingArr)
    state.unfindDictTypes = Array.from(targetArr)
  },
  //去除找不到的字典类型字段
  REMOVE_UNFIND_DICT_TYPES(typesStr) {
    const dictArr = typesStr.split(",")
    //arr1有 arr2没有的差集
    const targetArr = [...new Set(state.unfindDictTypes)].filter(item => !new Set(dictArr).has(item))
    state.unfindDictTypes = Array.from(targetArr)
  }
}

const actions = {
  getDictDataObj(dictType) {
    return new Promise((resolve, reject) => {
      const { storage, dictDataKey, getDictCodeApi, usuallyGetFileds, formatterRequest, query, versionKey, localDictCodes, formatterDictList, formatterDictVersion, isGetAll, filterDataFun, disabledDataFun } = state.dictConfig
      //字典数据
      const dictCodeList = state.dictCodes || localDictCodes
      //缓存找不到
      if (!dictCodeList[dictType] || dictCodeList[dictType].length === 0) {
        if (state.isGettingDictTypes.includes(dictType) || state.isGettingAllDictTypes) { return } //如果有别的地方在请求这个字典类型数据  停止操作
        mutations.ADD_IS_EGTTING_DICT_TYPES(dictType) //将这个字典类型列入到正在请求的字典数据当中
        if (state.unfindDictTypes.includes(dictType)) {
          // console.log(`不存在类型为：${dictType} 的字典字段，请确认后再填写`)
          reject(`不存在类型为：${dictType} 的字典字段，请确认后再填写`)
          return
        }
        //将此字典数据添加到找不到字典数据 记录起来
        mutations.ADD_UNFIND_DICT_TYPES(dictType)

        getDictCodeApi(formatterRequest(query, dictType)).then(data => {
          mutations.REMOVE_IS_EGTTING_DICT_TYPES(dictType) //将这个字典类型从正在请求的字典数据当中移除

          const version = formatterDictVersion(data)
          const currentversion = storage.getItem(versionKey) //当前字典数据的版本号
          if (version !== currentversion) { //当前版本不是最新版本
            let requestField = ""
            if (isGetAll) { //如果获取全部，则重新获取全部，否则获取该类型的即可
              requestField = ""
              mutations.SETTING_ISGETTING_ALL_DICT_TYPES(true) //设置正在请求所有字典为 true  禁止其他部门请求的 请求
            } else {
              if (usuallyGetFileds) { //获取常用字段
                const storageTypeArr = Object.keys(dictCodeList) //获取所有已缓存的字典字段（数组）
                const usuallyGetTypeArr = usuallyGetFileds.split(",")
                const arr = storageTypeArr.concat(usuallyGetTypeArr)
                arr.push(dictType)
                const resultArr = Array.from(new Set(arr))
                requestField = resultArr.join(",")
              } else {
                const storageTypeArr = Object.keys(dictCodeList) //获取所有已缓存的字典字段（数组）
                storageTypeArr.push(dictType)
                const resultArr = Array.from(new Set(storageTypeArr))
                requestField = resultArr.join(",")
              }
              mutations.ADD_IS_EGTTING_DICT_TYPES(requestField) //将这些字典类型列入到正在请求的字典数据当中
            } 
            
            //获取字典
            getDictCodeApi(formatterRequest(query, requestField)).then(data => {
              const allDictData = formatterDictList(data, dictType)
              if (!(allDictData[dictType]&&allDictData[dictType].length > 0)) {
                // console.log(`不存在类型为：${dictType} 的字典字段，请确认后再填写`)
                reject(`不存在类型为：${dictType} 的字典字段，请确认后再填写`)
                return
              }
              //将此字典数据类型从 找不到的字典数据类型 移除 
              mutations.REMOVE_UNFIND_DICT_TYPES(dictType)
              const version = formatterDictVersion(data)
              const dictObjs = Object.assign(JSON.parse(JSON.stringify(localDictCodes)), allDictData)

              const resultDictData = formatDictData(dictObjs, filterDataFun, disabledDataFun)
              storage.setItem(dictDataKey, JSON.stringify(resultDictData))
              storage.setItem(versionKey, version)
              mutations.SET_DICT_CODES(dictObjs)
              resolve(state.dictCodes)
              if (state.isGettingAllDictTypes) {
                mutations.SETTING_ISGETTING_ALL_DICT_TYPES(false) //请求结束 设置正在请求所有字典为 false  禁止其他部门请求的 请求
              } else {
                mutations.REMOVE_IS_EGTTING_DICT_TYPES(requestField) //将这个字典类型从正在请求的字典数据当中移除
              }
            })
          } else {
            const typeDictList = formatterDictList(data, dictType)
            if (!(typeDictList[dictType]&&typeDictList[dictType].length > 0)) {
              // console.log(`不存在类型为：${dictType} 的字典字段，请确认后再填写`)
              reject(`不存在类型为：${dictType} 的字典字段，请确认后再填写`)
              return
            }
            
            //将此字典数据类型从 找不到的字典数据类型 移除 
            mutations.REMOVE_UNFIND_DICT_TYPES(dictType)
            //再获取一次字典数据
            const dictData = state.dictCodes || localDictCodes
            const resultTypeList = formatDictData(typeDictList, filterDataFun, disabledDataFun)
            Object.assign(dictData, resultTypeList) //添加该类型的字典数据
            storage.setItem(dictDataKey, JSON.stringify(dictData)) //设置字典数据
            mutations.SET_DICT_CODES(dictData)
            resolve(state.dictCodes)
          }
        })
      } else {
        //将此字典数据类型从 找不到的字典数据类型 移除 
        mutations.REMOVE_UNFIND_DICT_TYPES(dictType)

        mutations.SET_DICT_CODES(dictCodeList)
        resolve(state.dictCodes)
      }
    })
  }
}

const store = {
  state,
  mutations,
  actions
}

export default store